import { Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { FIND_INSTANCES_QUERY } from '../api/instances-api';
import { InstancesTable } from './InstancesTable';

type InstancesInspectorProps = {
    instanceIds: string[];
};
export function InstancesInspector({ instanceIds }: InstancesInspectorProps) {
    const [allInstances, setAllInstances] = useState([] as PipelineInstance[]);

    useQuery(FIND_INSTANCES_QUERY, {
        variables: {
            instanceIds: instanceIds,
        },
        onCompleted: (data) => {
            const instancesArray = data?.response as PipelineInstance[];
            if (instancesArray != undefined) {
                setAllInstances(instancesArray);
            }
        },
        pollInterval: 2000,
    });

    return (
        <Modal isOpen={true} size={'6xl'} onClose={() => {}}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Instances inspector</ModalHeader>

                <ModalBody>
                    <InstancesTable instances={allInstances} />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
